import { useMemo, useEffect } from 'react';
import buildLendingOptions from '../helpers/buildLendingOptions.js';
const useLendingOptions = function () {
  let paymentCalculationDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let listingPaymentDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let obfuscatedCredit = arguments.length > 2 ? arguments[2] : undefined;
  let selectedLoanTerm = arguments.length > 3 ? arguments[3] : undefined;
  let vehicleCondition = arguments.length > 4 ? arguments[4] : undefined;
  let setLendingOptions = arguments.length > 5 ? arguments[5] : undefined;
  const paymentDetails = paymentCalculationDetails && Object.keys(paymentCalculationDetails).length ? paymentCalculationDetails : listingPaymentDetails;
  const options = useMemo(() => buildLendingOptions(paymentDetails, obfuscatedCredit, selectedLoanTerm, vehicleCondition), [paymentDetails, obfuscatedCredit, selectedLoanTerm, vehicleCondition]);
  useEffect(() => {
    setLendingOptions(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(options)]);
  return null;
};
export { useLendingOptions as default };
